import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import { UsersServerSideField } from 'src/components/common/users/users-serverside';
import { ResourcePageType, Tag, User } from 'src/graphql/generated/graphql';
import { ResourceFolderField } from '../../form/fields/folders';

export const getFilterConfig = ({
  t,
  tags,
  isUserResources,
}: {
  t: TFunction;
  tags: Tag[];
  isUserResources?: boolean;
}) => [
  {
    id: 'type',
    size: 3,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('resources.list.filter.type.label'),
        name: 'type',
        label: t('resources.list.filter.type.label'),
      },
      options: [
        {
          value: ResourcePageType.Document,
          name: t('resources.list.filter.type.document'),
        },
        {
          value: ResourcePageType.Download,
          name: t('resources.list.filter.type.download'),
        },
        {
          value: ResourcePageType.Video,
          name: t('resources.list.filter.type.video'),
        },
      ],
    },
  },
  {
    id: 'folderIds',
    size: 3,
    type: FilterItemType.Custom,
    render: (props: any) => {
      return <ResourceFolderField field={props} multiple={true} />;
    },
    props: {
      inputProps: {
        placeholder: t('resources.list.filter.folder'),
        name: 'folderIds',
        label: t('resources.list.filter.folder'),
      },
    },
  },
  {
    id: 'tagIds',
    size: 3,
    type: FilterItemType.Multiselect,
    props: {
      multiple: true,
      inputProps: {
        placeholder: t('common.tags'),
        name: 'tagIds',
        label: t('common.tags'),
      },
      options: tags.map((tag) => ({
        value: tag.id,
        name: tag.name,
      })),
    },
  },
  {
    id: 'createdByUserId',
    size: 3,
    type: FilterItemType.Custom,
    render: (props: any) => {
      return <UsersServerSideField {...props}></UsersServerSideField>;
    },
    props: {
      inputProps: {
        placeholder: t('resources.list.columns.added-by'),
        name: 'createdByUserId',
        label: t('resources.list.columns.added-by'),
      },
    },
  },
  ...(isUserResources
    ? []
    : [
        {
          id: 'isDisabled',
          size: 3,
          type: FilterItemType.Select,
          props: {
            disableClearable: false,
            inputProps: {
              placeholder: t('common.status.label'),
              name: 'isDisabled',
              label: t('common.status.label'),
            },
            options: [
              {
                value: false,
                name: t('common.active'),
              },
              {
                value: true,
                name: t('common.inactive'),
              },
            ],
          },
        },
      ]),
];
